import React from "react";
import { Link } from "react-router-dom";
import { PhoneCall, Mail, MapPin } from "lucide-react";
import "../styles/user/Footer.css";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="roomyrent-footer sp-simple-footer">
      <div className="footer-container">
        <div className="simple-footer-grid">
          {/* Column 1: Brand & Contact Info */}
          <div className="footer-col brand-col">
            <Link to="/" className="footer-logo-link">
              <img
                src="/icon-logo.png"
                alt="SP Home Logo"
                className="footer-brand-logo"
              />
              <span className="brand-name">SP Home</span>
            </Link>
            <p className="brand-desc">
              Nền tảng công nghệ quản lý nhà trọ và kết nối mạng lưới cho thuê phòng thông minh.
            </p>
            <div className="simple-contact-list">
              <a href="tel:0911742286" className="simple-contact-item" title="Gọi Hotline">
                <PhoneCall size={15} className="contact-icon" />
                <span>0911 742 286</span>
              </a>
              <a href="mailto:support@sphome.vn" className="simple-contact-item" title="Gửi Email">
                <Mail size={15} className="contact-icon" />
                <span>support@sphome.vn</span>
              </a>
              <div className="simple-contact-item">
                <MapPin size={15} className="contact-icon" />
                <span>60 Trần Đăng Ninh, Q. Hà Đông, Hà Nội</span>
              </div>
            </div>
          </div>

          {/* Column 2: Dành cho Chủ nhà */}
          <div className="footer-col">
            <h4 className="footer-title">Dành cho Chủ nhà</h4>
            <ul className="footer-links-list">
              <li>
                <Link to="/quan-ly-nha-tro/">Cẩm nang quản lý nhà trọ</Link>
              </li>
              <li>
                <Link to="/">Quản lý tòa nhà &amp; phòng</Link>
              </li>
              <li>
                <Link to="/contact/">Tư vấn quản lý khách thuê &amp; hợp đồng</Link>
              </li>
              <li>
                <Link to="/tinh-tien-dien-nuoc-phong-tro/">Tính tiền điện nước phòng trọ</Link>
              </li>
              <li>
                <Link to="/quan-ly-cong-no-tien-phong/">Quản lý công nợ &amp; thu chi</Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Cộng tác viên & Khách */}
          <div className="footer-col">
            <h4 className="footer-title">Cộng tác viên</h4>
            <ul className="footer-links-list">
              <li>
                <Link to="/cong-tac-vien-cho-thue-phong-tro/">Hướng dẫn cộng tác viên</Link>
              </li>
              <li>
                <Link to="/rooms">Danh sách phòng trống</Link>
              </li>
              <li>
                <Link to="/favourite">Phòng đã lưu yêu thích</Link>
              </li>
              <li>
                <Link to="/about">Giới thiệu về SP Home</Link>
              </li>
              <li>
                <Link to="/contact">Trung tâm hỗ trợ</Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Kênh kết nối */}
          <div className="footer-col">
            <h4 className="footer-title">Kết nối với chúng tôi</h4>
            <div className="simple-social-links">
              <a
                href="https://zalo.me/0911742286"
                target="_blank"
                rel="noopener noreferrer"
                className="simple-social-btn zalo"
              >
                <span>Chat Zalo</span>
              </a>
              {/* Facebook
              <a
                href="https://m.me/sphome"
                target="_blank"
                rel="noopener noreferrer"
                className="simple-social-btn fb"
              >
                <span>Facebook</span>
              </a>
              */}
              <a
                href="tel:0911742286"
                className="simple-social-btn phone"
              >
                <span>Hotline: 0911 742 286</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Copyright Line */}
        <div className="simple-footer-bottom">
          <p className="bottom-copy">
            © {currentYear} <strong>SP Home</strong>. Tất cả các quyền được bảo lưu.
          </p>
          <div className="bottom-links">
            <Link to="/about">Giới thiệu</Link>
            <span className="dot">•</span>
            <Link to="/contact">Điều khoản</Link>
            <span className="dot">•</span>
            <Link to="/contact">Chính sách bảo mật</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
